function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "Group_67879",
  "data-name": "Group 67879"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_52323",
  "data-name": "Path 52323",
  d: "M15.964,6.036a3.535,3.535,0,0,1,5,0h0a3.535,3.535,0,0,1,0,5l-5.879,5.879a3.535,3.535,0,0,1-5,0h0a3.535,3.535,0,0,1,0-5l.879-.879",
  fill: "none",
  stroke: "#1dbf73",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 1.5
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_52324",
  "data-name": "Path 52324",
  d: "M8.036,18.964a3.535,3.535,0,0,1-5,0h0a3.535,3.535,0,0,1,0-5L8.915,8.085a3.535,3.535,0,0,1,5,0h0a3.535,3.535,0,0,1,0,5L13,14",
  fill: "none",
  stroke: "#1dbf73",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 1.5
}));

var _ref3 = /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle_331",
  "data-name": "Rectangle 331",
  width: 24,
  height: 24,
  fill: "none"
});

function SvgAttachmentLink9(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "attachment-link.9",
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAttachmentLink9);
export default __webpack_public_path__ + "static/media/attachment-link.9.0ca0f9f3.svg";
export { ForwardRef as ReactComponent };